import React from 'react';
import ChatContainer from './components/chat/ChatContainer';

export default function App() {
  return <ChatContainer />;
}
